export default __webpack_public_path__ + "static/media/certificate-course.82b4d9d9.svg";